import { runtime } from '../../runtime/Runtime';
export class ActorAudio {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get actor() {
        return this.parent;
    }
    isMediaLabelAudioPlaying(label) {
        if (!runtime.availablePackages.Defer)
            return false;
        return !!this.actor.context.app.media.mediaPlayer.playerIntents.playingIntents.find(intent => intent.medFile.mediumLabel === label &&
            this.actor.actorMedia.allSoundsFiles.includes(intent.medFile));
    }
}
